import React, { useMemo, useRef } from 'react';

import FeedbackForm from '~/src/features/yandex-landing/FeedbackForm';
import Header from '~/src/features/yandex-landing/Header';
import PlusesBlock from '~/src/features/yandex-landing/PlusesBlock';
import RoutesBanner from '~/src/features/yandex-landing/RoutesBanner';
import SmartStationCarousel from '~/src/features/yandex-landing/SmartStationCarousel';
import type { IProps, IStationSections } from '~/src/features/yandex-landing/types';
import YandexCatalog from '~/src/features/yandex-landing/YandexCatalog';

import * as ST from './styled';

const YandexLanding: React.FC<IProps> = ({ city, yandexStationData }) => {
    const callbackFormRef = useRef<HTMLDivElement | null>(null);

    const stationMaxi = useMemo(() => yandexStationData.filter(
        item => item.props?.length
                ? item.props[0].value === '[4]'
                : null,
    )[0], [yandexStationData]);

    const stationLight = useMemo(() => yandexStationData.filter(
        item => item.props?.length
                ? item.props[0].value === '[1]'
                : null,
    )[0], [yandexStationData]);

    const stationSections = useMemo((): IStationSections[] => {
        const hasStation: IStationSections[] = [
            { value: 1, type: 'light', inStock: false },
            { value: 2, type: 'mini', inStock: false },
            { value: 3, type: 'standart', inStock: false },
            { value: 4, type: 'maxi', inStock: false },
            { value: 5, type: 'midi', inStock: false },
        ];
        hasStation.forEach((item, index) => {
            item.inStock = yandexStationData.some(station => station.props?.length ? station.props[0].value === `[${index + 1}]` : false);
            return item;
        });
        return hasStation;
    }, [yandexStationData]);

    return (
        <ST.LandingWrapper>
            <Header
                callbackRef={callbackFormRef}
                stationLight={stationLight}
                city={city}
                stationSections={stationSections}
            />
            <PlusesBlock callbackRef={callbackFormRef} stationMaxi={stationMaxi} stationLight={stationLight}/>
            <SmartStationCarousel/>
            <RoutesBanner/>
            <FeedbackForm
                city={city}
                ref={callbackFormRef}
                Container={ST.ContainerFeedbackForm}
                FormWrapper={ST.FeedbackFormWrapper}
                InputWrapperComponent={ST.InputWrapper}
                ButtonWrapperComponent={ST.ButtonWrapper}
                title='Поможем выбрать подходящую модель'
                subtitle='Легко ответим на любые ваши вопросы'
            />
            <YandexCatalog yandexStationData={yandexStationData}/>
        </ST.LandingWrapper>
    );
};

export default YandexLanding;
